import { useEffect } from "react";
import { Route, Switch, Redirect } from "wouter";
import { Toaster } from "sonner";
import "@/App.css";
import { useAuthStore } from "@/lib/stores/authStore";
import { useUiStore } from "@/lib/stores/uiStore";
import { useItemsStore } from "@/lib/stores/itemsStore";
import AppShell from "@/components/layout/AppShell";
import Login from "@/pages/Login";
import Inbox from "@/pages/Inbox";
import Biblioteca from "@/pages/Biblioteca";
import Buscar from "@/pages/Buscar";
import Proyectos from "@/pages/Proyectos";
import Tareas from "@/pages/Tareas";
import Asistente from "@/pages/Asistente";
import Ajustes from "@/pages/Ajustes";
import Etiquetas from "@/pages/Etiquetas";
import Integraciones from "@/pages/Integraciones";

function App() {
  const theme = useUiStore((s) => s.theme);
  const sessionToken = useAuthStore((s) => s.sessionToken);
  const boot = useItemsStore((s) => s.boot);

  useEffect(() => {
    document.documentElement.classList.toggle("dark", theme === "dark");
  }, [theme]);

  useEffect(() => {
    if (sessionToken) boot();
  }, [sessionToken, boot]);

  return (
    <>
      <Toaster position="bottom-right" toastOptions={{ style: { fontFamily: "Geist, sans-serif" } }} />
      <Switch>
        <Route path="/login">{sessionToken ? <Redirect to="/inbox" /> : <Login />}</Route>
        <Route>
          {!sessionToken ? (
            <Redirect to="/login" />
          ) : (
            <AppShell>
              <Switch>
                <Route path="/">
                  <Redirect to="/inbox" />
                </Route>
                <Route path="/inbox">
                  <Inbox />
                </Route>
                <Route path="/biblioteca">
                  <Biblioteca />
                </Route>
                <Route path="/buscar">
                  <Buscar />
                </Route>
                <Route path="/proyectos">
                  <Proyectos />
                </Route>
                <Route path="/tareas">
                  <Tareas />
                </Route>
                <Route path="/asistente">
                  <Asistente />
                </Route>
                <Route path="/ajustes">
                  <Ajustes />
                </Route>
                <Route path="/etiquetas">
                  <Etiquetas />
                </Route>
                <Route path="/integraciones">
                  <Integraciones />
                </Route>
                <Route>
                  <Redirect to="/inbox" />
                </Route>
              </Switch>
            </AppShell>
          )}
        </Route>
      </Switch>
    </>
  );
}

export default App;
